import {
  InfoPanelTitle,
  InfoPanelDescription,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function BusinessSetupInfoContent() {
  return (
    <>
      <InfoPanelTitle>How is your business set up?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          A sole proprietorship is a business owned and operated by one person.
        </p>
        <p>
          A limited liability company (LLC) is a registered business with
          liability protection.
        </p>
      </InfoPanelDescription>
    </>
  )
}
